import { Injectable } from "@angular/core";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from "../../shared";
import { ItemHdrWithMtoChildPricingContainer } from '../../../../../../models/aggregates/erp/financial';
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class ItemHdrWithMtoChildPricingService extends BaseApiTemplateService<ItemHdrWithMtoChildPricingContainer> {
  readonly endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "mto/child/pricing-schemes-links";
  readonly url = Core2Config.DOMAIN_URL + this.endpoint_path;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "mto/child/pricing-schemes-links";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "mto/child/pricing-schemes-links";
    this.httpClient = http;
  }

  getChildPricingWithEntityLogicByGuidPublic(visa: ApiVisa, guid: string, websiteGuid: string, entity_hdr_guid?: string) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/entity-branch/public-ep/' + guid;
    }
    const pathWithParams = this.apiUrl + "?" + "website_guid=" + websiteGuid + (entity_hdr_guid
      ? "&entity_hdr_guid=" + entity_hdr_guid : "");
    return this.httpClient.get<BasicApiResponseModel<ItemHdrWithMtoChildPricingContainer>>(pathWithParams, this.getHttpHeader(visa));
  }
}
